import { createFileRoute } from '@tanstack/react-router';
import { OnboardingShell } from '@/components/layout/OnboardingShell';

export const Route = createFileRoute('/onboarding/_layout')({
  component: OnboardingShell,
});
